module.exports = "/build/web/images/logo-sikkens.d9f28cc0591f6b29423fb1298a379279.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/logo-sikkens.jpeg
// module id = 121
// module chunks = 13